export const stripPrelude = (text: string) => {
  let mode: string | null = null;

  const body = (text || "").replace(
    /<!-- buttondown-editor-mode: ([a-z]+) -->/,
    (_, m) => ((mode = m), "")
  );

  // Not sure why `mode` is being typed as just `null`, maybe because
  // it thinks the `.replace()` method is async?
  return { body, mode: mode as string | null };
};

export const wrapInPrelude = (mode: "fancy" | "plaintext", text: string) => {
  return `<!-- buttondown-editor-mode: ${mode} -->` + text;
};
